import React, { useEffect, useRef } from "react";

// SASS
import "./Part6.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import protein1Img from "../../assets/img/protein-1.svg";
import protein2Img from "../../assets/img/protein-2.svg";
import protein3Img from "../../assets/img/protein-3.svg";
import protein4Img from "../../assets/img/protein-4.svg";
import protein5Img from "../../assets/img/protein-5.svg";
import protein6Img from "../../assets/img/protein-6.svg";
import protein7Img from "../../assets/img/protein-7.svg";

// FUNCTION EXPORT
export default function Part6({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "fade out protein1, fade in protein2",
    },
    {
      stepNumber: "2",
      height: null,
      description: "fade out protein2, fade in protein3, fade in shell text",
    },
    {
      stepNumber: "3",
      height: null,
      description:
        "fade out protein3, fade in protein4, fade out shell text, fade in bottom text1",
    },
    {
      stepNumber: "4",
      height: null,
      description:
        "fade out protein4, fade in protein5, fade out bottom text1, fade in bottom text2",
    },
    {
      stepNumber: "5",
      height: null,
      description:
        "fade out protein5, fade in protein6, fade out bottom text2, fade in bottom text3",
    },
    {
      stepNumber: "6",
      height: null,
      description: "fade out protein6, fade in protein7",
    },
    { stepNumber: "7", height: null, description: "spacer" },
    { stepNumber: "8", height: null, description: "spacer" },
    { stepNumber: "9", height: null, description: "spacer" },
  ];

  // REFS
  const protein1El = useRef(null);
  const protein2El = useRef(null);
  const protein3El = useRef(null);
  const protein4El = useRef(null);
  const protein5El = useRef(null);
  const protein6El = useRef(null);
  const protein7El = useRef(null);
  const shellTextEl = useRef(null);
  const bottomText1El = useRef(null);
  const bottomText2El = useRef(null);
  const bottomText3El = useRef(null);

  const protein1ElDesktop = useRef(null);
  const protein2ElDesktop = useRef(null);
  const protein3ElDesktop = useRef(null);
  const protein4ElDesktop = useRef(null);
  const protein5ElDesktop = useRef(null);
  const protein6ElDesktop = useRef(null);
  const protein7ElDesktop = useRef(null);
  const bottomText0ElDesktop = useRef(null);
  const bottomText1ElDesktop = useRef(null);
  const bottomText2ElDesktop = useRef(null);
  const bottomText3ElDesktop = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnEnter(protein1El.current, direction);
            animate.fadeInOnEnter(protein2El.current, direction);

            animate.fadeOutOnEnter(protein1ElDesktop.current, direction);
            animate.fadeInOnEnter(protein2ElDesktop.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnEnter(protein2El.current, direction);
            animate.fadeInOnEnter(protein3El.current, direction);
            animate.fadeInOnEnter(shellTextEl.current, direction);

            animate.fadeOutOnEnter(protein2ElDesktop.current, direction);
            animate.fadeInOnEnter(protein3ElDesktop.current, direction);
            animate.fadeInOnEnter(bottomText0ElDesktop.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnEnter(protein3El.current, direction);
            animate.fadeInOnEnter(protein4El.current, direction);
            animate.fadeInOnEnter(bottomText1El.current, direction);
            animate.fadeOutOnEnter(shellTextEl.current, direction);

            animate.fadeOutOnEnter(protein3ElDesktop.current, direction);
            animate.fadeInOnEnter(protein4ElDesktop.current, direction);
            animate.fadeInOnEnter(bottomText1ElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnEnter(protein4El.current, direction);
            animate.fadeInOnEnter(protein5El.current, direction);
            animate.fadeInOnEnter(bottomText2El.current, direction);
            //animate.fadeOutOnEnter(bottomText1El.current, direction);

            animate.fadeOutOnEnter(protein4ElDesktop.current, direction);
            animate.fadeInOnEnter(protein5ElDesktop.current, direction);
            animate.fadeInOnEnter(bottomText2ElDesktop.current, direction);
            break;
          }
          case "5": {
            animate.fadeOutOnEnter(protein5El.current, direction);
            animate.fadeInOnEnter(protein6El.current, direction);
            animate.fadeInOnEnter(bottomText3El.current, direction);
            //animate.fadeOutOnEnter(bottomText2El.current, direction);

            animate.fadeOutOnEnter(protein5ElDesktop.current, direction);
            animate.fadeInOnEnter(protein6ElDesktop.current, direction);
            animate.fadeInOnEnter(bottomText3ElDesktop.current, direction);
            break;
          }
          case "6": {
            animate.fadeOutOnEnter(protein6El.current, direction);
            animate.fadeInOnEnter(protein7El.current, direction);

            animate.fadeOutOnEnter(protein6ElDesktop.current, direction);
            animate.fadeInOnEnter(protein7ElDesktop.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnExit(protein1El.current, direction);
            animate.fadeOutOnExit(protein2El.current, direction);

            animate.fadeInOnExit(protein1ElDesktop.current, direction);
            animate.fadeOutOnExit(protein2ElDesktop.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnExit(protein2El.current, direction);
            animate.fadeOutOnExit(protein3El.current, direction);
            animate.fadeOutOnExit(shellTextEl.current, direction);

            animate.fadeInOnExit(protein2ElDesktop.current, direction);
            animate.fadeOutOnExit(protein3ElDesktop.current, direction);
            animate.fadeOutOnExit(bottomText0ElDesktop.current, direction);

            break;
          }
          case "3": {
            animate.fadeInOnExit(protein3El.current, direction);
            animate.fadeOutOnExit(protein4El.current, direction);
            animate.fadeOutOnExit(bottomText1El.current, direction);
            animate.fadeInOnExit(shellTextEl.current, direction);

            animate.fadeInOnExit(protein3ElDesktop.current, direction);
            animate.fadeOutOnExit(protein4ElDesktop.current, direction);
            animate.fadeOutOnExit(bottomText1ElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnExit(protein4El.current, direction);
            animate.fadeOutOnExit(protein5El.current, direction);
            animate.fadeOutOnExit(bottomText2El.current, direction);
            // animate.fadeInOnExit(bottomText1El.current, direction);

            animate.fadeInOnExit(protein4ElDesktop.current, direction);
            animate.fadeOutOnExit(protein5ElDesktop.current, direction);
            animate.fadeOutOnExit(bottomText2ElDesktop.current, direction);
            break;
          }
          case "5": {
            animate.fadeInOnExit(protein5El.current, direction);
            animate.fadeOutOnExit(protein6El.current, direction);
            animate.fadeOutOnExit(bottomText3El.current, direction);
            //  animate.fadeInOnExit(bottomText2El.current, direction);

            animate.fadeInOnExit(protein5ElDesktop.current, direction);
            animate.fadeOutOnExit(protein6ElDesktop.current, direction);
            animate.fadeOutOnExit(bottomText3ElDesktop.current, direction);
            break;
          }
          case "6": {
            animate.fadeInOnExit(protein6El.current, direction);
            animate.fadeOutOnExit(protein7El.current, direction);

            animate.fadeInOnExit(protein6ElDesktop.current, direction);
            animate.fadeOutOnExit(protein7ElDesktop.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part6">
          <div className="top-text">
            All viruses have <b>proteins</b>, <br />
            <b>just like us.</b>
          </div>
          <div className="protein-container-mobile">
            <div className="protein-container">
              <div className="top-graphic">
                <div className="protein protein-1" ref={protein1El}>
                  <img src={protein1Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-2" ref={protein2El}>
                  <img src={protein2Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-3" ref={protein3El}>
                  <img src={protein3Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-4" ref={protein4El}>
                  <img src={protein4Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-5" ref={protein5El}>
                  <img src={protein5Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-6" ref={protein6El}>
                  <img src={protein6Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-7" ref={protein7El}>
                  <img src={protein7Img} alt="" className="img-fluid" />
                </div>
                <div className="top-graphic__text" ref={shellTextEl}>
                  Proteins come together to create a <b>shell.</b>
                </div>
              </div>
              <div className="bottom-text">
                <div className="text text-1" ref={bottomText1El}>
                  This shell, or capsid, protects the genes from damage.
                </div>
                <div className="text text-2" ref={bottomText2El}>
                  Some proteins stick out from the shell.
                </div>
                <div className="text text-2" ref={bottomText3El}>
                  Other proteins stay inside the shell and only come out to make
                  more virus copies.
                </div>
              </div>
            </div>
          </div>
          <div className="protein-container-desktop">
            <div className="protein-container">
              <div className="bottom-text">
                <div className="text text-1" ref={bottomText0ElDesktop}>
                  Proteins come together to create a <b>shell.</b>
                </div>
                <div className="text text-2" ref={bottomText1ElDesktop}>
                  This shell, or capsid, protects the genes from damage.
                </div>
                <div className="text text-2" ref={bottomText2ElDesktop}>
                  Some proteins stick out from the shell.
                </div>
                <div className="text text-2" ref={bottomText3ElDesktop}>
                  Other proteins stay inside the shell and only come out to make
                  more virus copies.
                </div>
              </div>
              <div className="top-graphic">
                <div className="protein protein-1" ref={protein1ElDesktop}>
                  <img src={protein1Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-2" ref={protein2ElDesktop}>
                  <img src={protein2Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-3" ref={protein3ElDesktop}>
                  <img src={protein3Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-4" ref={protein4ElDesktop}>
                  <img src={protein4Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-5" ref={protein5ElDesktop}>
                  <img src={protein5Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-6" ref={protein6ElDesktop}>
                  <img src={protein6Img} alt="" className="img-fluid" />
                </div>
                <div className="protein protein-7" ref={protein7ElDesktop}>
                  <img src={protein7Img} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
